/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUpdateExternePersonDto } from '../../models/create-update-externe-person-dto';
import { PersonWithZugaengeDto } from '../../models/person-with-zugaenge-dto';

export interface CreateExtern$Json$Params {
  
    /**
     * Daten für die externe Entität
     */
    body?: CreateUpdateExternePersonDto
}

export function createExtern$Json(http: HttpClient, rootUrl: string, params?: CreateExtern$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PersonWithZugaengeDto>>> {
  const rb = new RequestBuilder(rootUrl, createExtern$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PersonWithZugaengeDto>>;
    })
  );
}

createExtern$Json.PATH = '/v1/personzugaenge';
